<template>
  <section class="_menu-section-style">
    <form-section label="Alinhamento" v-model="isExpanded.alignment">
      <Alignment :selectedSection="selectedSection" :hide="['vertical']"/>
    </form-section>

    <form-section label="Título" v-model="isExpanded.title">
      <Texts textType="title" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts textType="text" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>

    <form-section label="Formulário" v-model="isExpanded.form">
      <v-row no-gutters>
        <v-col cols="6" class="_pr-">
          <ColorPickerV2 title="Cor de fundo" :colorSelected="selectedSection" type="layer-color" />             
        </v-col>
        <v-col cols="6" class="_pl-">
          <ColorPickerV2 title="Cor do texto" :colorSelected="selectedSection" type="text-color" />             
        </v-col>

        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pr-">
          <ColorPickerV2 title="Cor botão" :colorSelected="selectedSection.buttons[0]" type="background-color" />             
        </v-col>
        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pl-">
          <ColorPickerV2 title="Cor de texto botão" :colorSelected="selectedSection.buttons[0]" type="color" />             
        </v-col>
        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pr-">
          <TextField 
            v-model="fontSize.buttonBorderRadius"
            label="Borda do botão"
            placeholder="px"
            type="number"
            :minValueForNumber="0"
            @input="updateSize($event, selectedSection.buttons[0], 'border')"
          />            
        </v-col>
      </v-row>
    </form-section>   

    <form-section label="Campanhas" v-model="isExpanded.campaign" :divider="false">
      <Select 
        v-model="selectedSection.token" 
        :items="getCampaigns"
        item-text="nome"
        item-value="token"         
        :showBorder="true"
      />
    </form-section>     
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Background from '../forms/formsV2/Background.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import TextField from '../../_v2/ui/TextField.vue'
import Select from '../../_v2/ui/Select.vue'

export default {
  name: 'CampaignSection',
  components: { FormSection, Texts, Background, ColorPickerV2, TextField, Alignment, Select},
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  computed: {
    ...mapGetters(['campaings']),
    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    },

    getCampaigns () {
      return this.campaings ? this.campaings.filter(c => c.tipo === 'V' || c.tipo === 'Y' || c.tipo === 'C') : []
    }
  },  

  data: () => ({
    fontSize: { buttonBorderRadius: '' },
    isExpanded: {alignment: true, title: true, text: true, bg: true, form: true, campaign: true}    
  }),

  mounted () {
    this.formatOnInit()
  },     

  methods: {
    formatOnInit() {
      if (this.selectedSection.buttons[0]["button-border-radius"]) {
        this.fontSize.buttonBorderRadius = this.selectedSection.buttons[0]["border-radius"].split("px")[0]
      }
    },

    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    updateSize(event, type, border) {
      let model = "";
      model = event + "px";
      if (border === "border") type["border-radius"] = model;
      else type["font-size"] = model;
    }    
  },

  watch: {
    'selectedSection.token' (token) {
      const campaign = this.getCampaigns.find(campaign => campaign.token === token)
    }
  }    
}
</script>

<style scoped>
</style>